exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rule-input[data-v-35596f79]  .el-input__inner{border:0}.avatar-uploader .el-upload[data-v-35596f79]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-35596f79]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-35596f79]{font-size:28px;color:#8c939d;width:100px;height:100px;line-height:100px;text-align:center}.avatar[data-v-35596f79]{width:100px;height:100px;display:block}\n", ""]);

// exports
